'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  padding: 16px;\n  border: 1px solid var(--theme-border, #e1e8ed);\n  border-radius: 16px;\n  background: var(--theme-surface, #ffffff);\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  min-height: ",
        "px;\n  padding: 12px;\n  border: 1px solid ",
        ";\n  border-radius: 12px;\n  font-size: 16px;\n  line-height: 1.5;\n  resize: none;\n  outline: none;\n  font-family: inherit;\n  overflow: hidden;\n  \n  &:focus {\n    border-color: var(--theme-primary, #1da1f2);\n    box-shadow: 0 0 0 2px rgba(29, 161, 242, 0.1);\n  }\n\n  &::placeholder {\n    color: var(--theme-text-secondary, #657786);\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 12px;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  font-size: 14px;\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  color: #e0245e;\n  font-size: 14px;\n  margin-top: 8px;\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  padding: 12px;\n  margin-bottom: 12px;\n  background: var(--theme-background-secondary, #f7f9fa);\n  border-radius: 12px;\n  border-left: 3px solid var(--theme-primary, #1da1f2);\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  color: var(--theme-text-secondary, #657786);\n  font-size: 14px;\n  margin-bottom: 4px;\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  font-size: 14px;\n  color: var(--theme-text-primary, #14171a);\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
/**
 * 📝 트윗 작성 컴포넌트
 * FSD features 레이어 - 트윗 작성 기능
 */ import React, { useState, useRef, useCallback, useLayoutEffect } from 'react';
import styled from '@emotion/styled';
import { useForm } from 'react-hook-form';
import { Button } from '@edusense/shared-ui-kit';
import { validateTweetContent } from '../../utils/validation';
import { tweet_composer_default_placeholder, tweet_submit_failed, tweet_reply_to_user, tweet_validation_required, tweet_validation_max_length, tweet_button_reply, tweet_button_tweet } from '@paraglide/messages';
var ComposerContainer = styled.div(_templateObject());
var MIN_TEXTAREA_HEIGHT = 120;
var TextArea = styled.textarea(_templateObject1(), MIN_TEXTAREA_HEIGHT, function(props) {
    return props.hasError ? '#e0245e' : 'var(--theme-border, #e1e8ed)';
});
var Footer = styled.div(_templateObject2());
var CharCount = styled.span(_templateObject3(), function(props) {
    return props.isOverLimit ? '#e0245e' : props.isNearLimit ? '#ffad1f' : 'var(--theme-text-secondary, #657786)';
});
var ErrorMessage = styled.div(_templateObject4());
var ReplyContainer = styled.div(_templateObject5());
var ReplyText = styled.div(_templateObject6());
var ReplyContent = styled.div(_templateObject7());
export function TweetComposer(param) {
    var _param_placeholder = param.placeholder, placeholder = _param_placeholder === void 0 ? tweet_composer_default_placeholder() : _param_placeholder, _param_maxLength = param.maxLength, maxLength = _param_maxLength === void 0 ? 280 : _param_maxLength, onSubmit = param.onSubmit, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, _param_initialContent = param.initialContent, initialContent = _param_initialContent === void 0 ? "" : _param_initialContent, replyTo = param.replyTo;
    var _useState = _sliced_to_array(useState(false), 2), isSubmitting = _useState[0], setIsSubmitting = _useState[1];
    var textareaRef = useRef(null);
    var _useForm = useForm({
        defaultValues: {
            content: initialContent
        }
    }), register = _useForm.register, handleSubmit = _useForm.handleSubmit, watch = _useForm.watch, errors = _useForm.formState.errors, reset = _useForm.reset;
    var content = watch('content');
    var charCount = (content === null || content === void 0 ? void 0 : content.length) || 0;
    var isNearLimit = charCount > maxLength * 0.8;
    var isOverLimit = charCount > maxLength;
    var adjustTextareaHeight = useCallback(function() {
        var textarea = textareaRef.current;
        if (!textarea) {
            return;
        }
        textarea.style.height = 'auto';
        var nextHeight = Math.max(textarea.scrollHeight, MIN_TEXTAREA_HEIGHT);
        textarea.style.height = "".concat(nextHeight, "px");
    }, []);
    useLayoutEffect(function() {
        adjustTextareaHeight();
    }, [
        content,
        adjustTextareaHeight
    ]);
    var _register = register('content', {
        required: tweet_validation_required(),
        maxLength: {
            value: maxLength,
            message: "".concat(maxLength).concat(tweet_validation_max_length())
        },
        validate: function(value) {
            var validation = validateTweetContent(value, maxLength);
            return validation.isValid || validation.error;
        }
    }), registerContentRef = _register.ref, registerContent = _object_without_properties(_register, [
        "ref"
    ]);
    var handleFormSubmit = useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(data) {
            var validation, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (isSubmitting || disabled) return [
                            2
                        ];
                        validation = validateTweetContent(data.content, maxLength);
                        if (!validation.isValid) {
                            return [
                                2
                            ];
                        }
                        setIsSubmitting(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            onSubmit(data.content)
                        ];
                    case 2:
                        _state.sent();
                        reset();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        console.error(tweet_submit_failed(), error);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setIsSubmitting(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(), [
        isSubmitting,
        disabled,
        maxLength,
        onSubmit,
        reset
    ]);
    return /*#__PURE__*/ React.createElement(ComposerContainer, null, replyTo && /*#__PURE__*/ React.createElement(ReplyContainer, null, /*#__PURE__*/ React.createElement(ReplyText, null, "@", replyTo.author.username, tweet_reply_to_user()), /*#__PURE__*/ React.createElement(ReplyContent, null, replyTo.content)), /*#__PURE__*/ React.createElement("form", {
        onSubmit: handleSubmit(handleFormSubmit)
    }, /*#__PURE__*/ React.createElement(TextArea, _object_spread_props(_object_spread({}, registerContent), {
        ref: function(node) {
            registerContentRef(node);
            textareaRef.current = node;
        },
        placeholder: placeholder,
        disabled: disabled || isSubmitting,
        hasError: !!errors.content || isOverLimit
    })), errors.content && /*#__PURE__*/ React.createElement(ErrorMessage, null, errors.content.message), /*#__PURE__*/ React.createElement(Footer, null, /*#__PURE__*/ React.createElement(CharCount, {
        isNearLimit: isNearLimit && !isOverLimit,
        isOverLimit: isOverLimit
    }, charCount, "/", maxLength), /*#__PURE__*/ React.createElement(Button, {
        type: "submit",
        variant: "primary",
        disabled: disabled || isSubmitting || isOverLimit || !(content === null || content === void 0 ? void 0 : content.trim()),
        isLoading: isSubmitting
    }, replyTo ? tweet_button_reply() : tweet_button_tweet()))));
}
